import { atom } from "jotai";
import { State } from "./State";
import { fetchBase, postBase } from "./BaseApi";

export type UserPointHistory = {
  id: number;
  pointOwnerId: number;
  eventDate: string;
  pointChange: number;
  createdAt: string;
  giftName: string;
  giftType: string;
};

const uri = "api/users/point";

export type FetchUserPointHistoryParam = {
  pointOwnerId?: number;
};

export const fetchUserPointHistoryAtom = atom<State<UserPointHistory> | null>(null);
export const fetchUserPointHistory = () => {
  return fetchBase<UserPointHistory, FetchUserPointHistoryParam>(uri, fetchUserPointHistoryAtom);
};


export type PostUserPointHistoryParam = {
  giftId: string;
  pointOwnerId?: number;
};

export type PostUserGiftEmailAuthExchangeParam = {
  token: string;
  giftId: string;
  pointOwnerId?: number;
};

export const postUserPointHistoryAtom = atom<State<void> | null>(null);
export const postUserPointHistory = () => {
  return postBase<void, PostUserPointHistoryParam>(uri, postUserPointHistoryAtom);
};

const giftEmailAuthExchangeUri = "api/users/gift-email-auth/exchange";
export const postUserGiftEmailAuthExchangeAtom = atom<State<void> | null>(null);
export const postUserGiftEmailAuthExchange = () => {
  return postBase<void, PostUserGiftEmailAuthExchangeParam>(
    giftEmailAuthExchangeUri,
    postUserGiftEmailAuthExchangeAtom
  );
};
